import React from 'react';
import Event from './Event.js';
import ModalForm from './Form/Form.js';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import ApiRequest from './ApiRequest';
import moment from 'moment';

export default class NotesModal extends ModalForm {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            form: {
                content: '',
                user: null,
                uid: null,
                updated_at: null
            },
            user: null,
            errors: {},
            errorMessage: null,
            successMessage: null,
            loading: false
        };
    }

    componentDidMount() {
        if (this.props.show) {
            this.setState({show: true});
        }

        Event.on('notesModal.show', (user) => {
            if (window.loggedInUser && [2, 3].indexOf(window.loggedInUser.type) !== -1) {
                let form = {
                    user: user.uid,
                    content: user.note ? user.note : '',
                    updated_at: user.note_updated_at ? user.note_updated_at : null
                };
                this.setState({
                    show: true,
                    user: user,
                    form
                });
            } else {
                window.location.href = "/login";
            }
        }, this._rootNodeID);

        Event.on('modals.close', () => {
            this.setState({show: false});
        }, this._rootNodeID);
    }

    componentWillUnmount() {
        Event.off('notesModal.show', this._rootNodeID);
        Event.off('modals.close', this._rootNodeID);
    }

    saveNote() {
        let request = new ApiRequest();
        this.setState({loading: true}, () => {
            request.post(`application/note`, this.state.form, (err, res) => {
                if (res && res.body && res.body.success) {
                    if (this.props.noteAdded) {
                        this.props.noteAdded(this.state.form.user, this.state.form.content);
                    }
                    this.toggle();
                } else {
                    Bugsnag.notify('Anyone - NotesModal@saveNote:', 'Unexpected error', { err, res });
                }
                this.setState({loading: false});
            });
        })
    }

    clearNote() {
        let form = this.state.form;
        form.content = "";
        this.setState({form}, () => this.saveNote());
    }

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={() => this.toggle()}>
                <ModalHeader toggle={() => this.toggle()}>
                    Notes {this.state.user ? ` - ${this.state.user.firstname} ${this.state.user.lastname}` : ''}
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <div className={'form-group ' + this.getErrorClass('content')}>
                                <textarea onChange={(e) => this.handleChange('content', e.target.value)} className="form-control" rows="10" placeholder="You can enter notes about this candidate here." value={this.state.form.content}></textarea>
                                {this.showError('content')}
                            </div>
                            {this.state.loading ? (
                                <div className="row">
                                    <div className="col-12">
                                        <button type="button" className="btn btn-primary btn-block mt-3">
                                            <i style={{
                                                width: '100%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto',
                                                fontSize: '1rem'
                                            }} className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i></button>
                                    </div>
                                </div>
                            ) : (
                                <div className="row">
                                    <div className="col-md-6">
                                        <button type="button" onClick={() => this.clearNote()} className="btn btn-warning btn-block mt-3">Clear</button>
                                    </div>
                                    <div className="col-md-6">
                                        <button type="button" onClick={() => this.saveNote()} className="btn btn-primary btn-block mt-3">Save</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="row">
                        <div className="col">
                            <p>*Notes only visible in ‘detailed view’</p>
                        </div>
                        <div className="col">
                            <p className="text-right">{this.state.form.content && this.state.form.updated_at ? ('Last update: ' + moment(this.state.form.updated_at).format("Do, MMMM  YYYY HH:mm")) : null}</p>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}